import React from 'react';
import PropTypes from 'prop-types';

import {Box, Skeleton, Typography} from 'views/components';

const FilterBarChip = (props) => {
  const {
    label,
    count,
    icon: Icon,
    isCountLoading = false,
    isSelected = false,
    onClick,
    sx = {},
    ...rest
  } = props;

  const displayCount = count;
  const shouldRenderCount = isCountLoading || typeof count === 'number';

  return (
    <Box
      onClick={onClick}
      sx={{
        'cursor': 'pointer',
        'display': 'flex',
        'alignItems': 'center',
        'gap': 1,
        'px': {xs: 2.25, md: 3},
        'py': {xs: 0.9, md: 1.1},
        'borderRadius': 3,
        'border': '2px solid',
        'color': isSelected ? 'common.white' : 'text.primary',
        '&:hover': {
          transform: 'scale(1.03)',
        },
        ...sx,
      }}
      {...rest}
    >
      {Icon && <Icon sx={{fontSize: {xs: 18, md: 20}}} />}
      <Typography
        sx={{
          whiteSpace: 'nowrap',
          fontWeight: 700,
          fontSize: {xs: '0.85rem', md: '0.9rem'},
        }}
      >
        {label}
      </Typography>
      {
        shouldRenderCount &&
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: {xs: 22, md: 24},
            height: {xs: 22, md: 24},
            px: 0.5,
            borderRadius: '999px',
            backgroundColor: isSelected ? 'rgba(0,0,0,0.14)' : 'rgba(0,0,0,0.05)',
          }}
        >
          {
            isCountLoading ?
              <Skeleton
                variant='rounded'
                sx={{
                  width: {xs: 14, md: 16},
                  height: {xs: 12, md: 14},
                }}
              /> :
              <Typography
                sx={{
                  whiteSpace: 'nowrap',
                  fontWeight: 600,
                  fontSize: {xs: '0.8rem', md: '0.85rem'},
                }}
              >
                {displayCount}
              </Typography>
          }
        </Box>
      }
    </Box>
  );
};

FilterBarChip.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number,
  icon: PropTypes.elementType,
  isCountLoading: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  sx: PropTypes.object,
};

export default FilterBarChip;
